<template>
    <div :class="showBlock?'goTop':''" ref="fr_bel">
        <div class="pay nameBox">
            <span class="payid">Name</span>
            <div class="pay-ipt-box">
                <input class="pay-ipt" :class="firstNameError?'errBorder':''" v-model="firstName" placeholder="First Name" @blur="validateName(1)"/>
                <input class="pay-ipt" :class="lastNameError?'errBorder':''" v-model="lastName" placeholder="Last Name" @blur="validateName(2)"/>
            </div>
            <span class="errtxt" v-if="firstNameError || lastNameError">{{ firstNameError || lastNameError }}</span>
        </div>
        <!-- 法国和比利时需要iban -->
        <div class="pay" v-if="countryType==1 || countryType==2">
            <span class="payid">IBAN Number</span>
            <input class="pay-ipt" :class="ibanNumberError?'errBorder':''" v-model="ibanNumber" placeholder="IBAN Number" 
            @blur="validateIBAN"/>
            <span class="errtxt" v-if="ibanNumberError">{{ ibanNumberError }}</span>
        </div>
        <!-- 摩洛哥时展示 -->
        <div class="pay" v-if="countryType==3">
            <span class="payid">RIB</span>
            <input class="pay-ipt" :class="ribNumberError?'errBorder':''" v-model="ribNumber" placeholder="RIB Number" 
            @blur="validateRib"/>
            <span class="errtxt" v-if="ribNumberError">{{ ribNumberError }}</span>
        </div>
        <!-- 阿尔及利亚时展示 -->
        <div class="pay" v-if="countryType==4">
            <span class="payid">Account Number</span>
            <input class="pay-ipt" :class="accountNumberError?'errBorder':''" v-model="accountNumber" placeholder="Account Number" 
            @blur="validateAccountNumber"/>
            <span class="errtxt" v-if="accountNumberError">{{ accountNumberError }}</span>
        </div>
        <div class="pay" v-if="countryType==4">
            <span class="payid">SWIFT Code</span>
            <input class="pay-ipt" :class="swiftCodeError?'errBorder':''" v-model="swiftCode" placeholder="SWIFT Code" 
            @blur="validateSwiftCodeError"/>
            <span class="errtxt" v-if="swiftCodeError">{{ swiftCodeError }}</span>
        </div>
        <div class="pay">
            <span class="payid">Address</span>
            <input class="pay-ipt" v-model="address" placeholder="address"
            :class="addressError?'errBorder':''"
            @blur="validateAddress"/>
            <span class="errtxt" v-if="addressError">{{ addressError }}</span>
        </div>
        <div class="pay">
          <span class="payid">whatsApp</span>
          <input class="pay-ipt" v-model="whatsApp" type="number" 
          :class="whatsAppError?'errBorder':''"
          @focus="showBlockBottom"
            @blur="hideBlockBottom"/>
          <span class="errtxt" v-if="whatsAppError">{{
            $t("withdrawalLogin.Whatsapp")
          }}</span>
          <div class="pay-txt">请留下你的联系方式，我们将用WhatsApp和你联系</div> 
          <!-- <div class="pay-txt">{{ detailsObj.pnotherTip }}</div> -->
        </div>
        <div class="gPayBtn" @click="gPaySubmit">{{ $t('withdrawalLogin.Confirm') }}</div>
    </div>
</template>
<script>
import axios from "axios";
import { Toast } from "vant";
export default {
  name: "fr_bel",
  data() {
    return {
        showBlock: false,
        firstName:'',
        firstNameError:'',
        lastName:'',
        lastNameError:'',
        ibanNumber:'',
        ibanNumberError:'',
        address:'',
        addressError:'',
        whatsApp:'',
        whatsAppError:'',
        ribNumber:'',
        ribNumberError:'',
        accountNumber:'',   
        accountNumberError:'',    
        swiftCode:'',
        swiftCodeError:'',
        // 判断是法国还是比利时 1法国 2比利时 3摩洛哥 4阿尔及利亚
        countryType:4
    }
  },
  computed: {
    // 定义不同国家的校验规则
    ibanRules() {
      return {
        1: {
          countryCode: 'FR',
          length: 27,
          digitsLength: 25,
          displayName: 'France (FR)'
        },
        2: {
          countryCode: 'BE',
          length: 16,
          digitsLength: 14,
          displayName: 'Belgium (BE)'
        },
        3: {
          countryCode: 'MA',
          length: 27,
          digitsLength: 25,
          displayName: 'Morocco (MA)'
        },
        4: {
          countryCode: 'DZ',
          length: 24,
          digitsLength: 22,
          displayName: 'Algeria (DZ)'
        },
      };
    },
    currentRule() {
      return this.ibanRules[this.countryType];
    },
  },
  methods:{
     gPaySubmit(){
      console.log('确定事件')
      // if(this.gPayInfoAll){
      //   this.submitBtn();
      // }else{
      //   Toast(this.gPayTips);
      // }
      // axios({
      //   url: that.$serviceIp + `api/trade/card/tx/applyForWeb`,
      //   method: "post",
      //     headers: {
      //       'deviceId': that.deviceId
      //     },
      //   data: {
      //     cid: that.detailsNewObj.id + "",
      //     params: paramsObj,
      //   },
      //   params: { token: that.token, uid: that.uid },
      // }).then((res) => {
      //   if (res.data.code == 200) {
      //     this.changeMate = true;
      //     localStorage.setItem("num", that.num);
      //     localStorage.setItem("id", that.id);
      //     setTimeout(this.nshbhxbh, 3000);
      //   } else {
      //     Toast(res.data.message || this.$t("transfer.error"));
      //   }
      //   this.loadingShow = false
      // });
    }, 
    // 校验 swift code
    validateSwiftCodeError(){
      let code = this.swiftCode;
       if (typeof code !== "string") return false;
      // 去掉空格并转换为大写
      code = code.trim().toUpperCase();
      // 长度必须为 8 或 11
      if (code.length !== 8 && code.length !== 11){
        this.swiftCodeError = 'SWIFT Code must be 8 or 11 characters.';
        return false;
      };
      // 只能包含字母和数字
      if (!/^[A-Z0-9]+$/.test(code)){
        this.swiftCodeError = 'SWIFT Code must be only letters and numbers.';
        return false;
      };
      // 前4位必须是字母（银行代码）
      if (!/^[A-Z]{4}/.test(code)) {
        this.swiftCodeError = 'SWIFT Code must be only letters and numbers.';
        return false;
      };
      // 第5-6位必须是字母（国家代码）
      if (!/^[A-Z]{4}[A-Z]{2}/.test(code)){
        this.swiftCodeError = 'SWIFT Code must be only letters and numbers.';
        return false;
      };
      // 第7-8位可以是字母或数字，但不能全是 "0"
      const locationCode = code.substring(6, 8);
      if (!/^[A-Z0-9]{2}$/.test(locationCode)) {
        this.swiftCodeError = 'SWIFT Code must be only letters and numbers.';
        return false;
      };
      if (locationCode === "00"){
        this.swiftCodeError = 'SWIFT Code must be only letters and numbers.';
        return false;
      };
      // 如果有第9-11位，也必须是字母或数字
      if (code.length === 11 && !/^[A-Z0-9]{3}$/.test(code.substring(8))) {
        this.swiftCodeError = 'SWIFT Code must be only letters and numbers.';
        return false;
      };
      return true;
    },
    // 校验account number
    validateAccountNumber(){
      const value = this.accountNumber.trim(); // 去除首尾空格
      // 检查是否为空（即长度为 0）
      if (value === '') {
        this.accountNumberError = 'Account Number is required.';
        return false;
      }
      // 检查长度是否在 1~50 范围内
      if (value.length > 50) {
        this.accountNumberError = 'Account Number must be no more than 50 characters.';
        return false;
      }
      // 校验通过，清空错误
      this.accountNumberError = '';
      return true;
    },
    // 校验地址
    validateAddress() {
      const value = this.address.trim(); // 去除首尾空格
      // 检查是否为空（即长度为 0）
      if (value === '') {
        this.addressError = 'Address is required.';
        return false;
      }
      // 检查长度是否在 1~200 范围内
      if (value.length > 200) {
        this.addressError = 'Address must be no more than 200 characters.';
        return false;
      }
      // 校验通过，清空错误
      this.addressError = '';
      return true;
    },
    // 校验iban
    validateIBAN() {
      const value = this.ibanNumber.replace(/\s/g, ''); // 去空格
      // 1. 检查是否为空
      if (!value) {
        this.ibanNumberError = 'IBAN Number is required.';
        return false;
      }
      // 如果 countryType 不支持
      if (!this.currentRule) {
        this.ibanNumberError = 'Unsupported country.';
        return false;
      }
      const { countryCode, length, digitsLength, displayName } = this.currentRule;
      // 2. 检查总长度
      if (value.length !== length) {
        this.ibanNumberError = `IBAN for ${displayName} must be exactly ${length} characters.`;
        return false;
      }
      // 3. 检查国家代码（不区分大小写）
      const inputCountryCode = value.slice(0, 2).toUpperCase();
      if (inputCountryCode !== countryCode) {
        this.ibanNumberError = `IBAN must start with "${countryCode}" for ${displayName}.`;
        return false;
      }
      // 4. 检查后 N 位是否为数字
      const digitsPart = value.slice(2);
      if (!/^\d+$/.test(digitsPart)) {
        this.ibanNumberError = `The remaining ${digitsLength} characters must be digits.`;
        return false;
      }
      if (digitsPart.length !== digitsLength) {
        this.ibanNumberError = `Expected ${digitsLength} digits after country code.`;
        return false;
      }
      // 校验通过
      this.ibanNumberError = '';
      return true;
    },
    // 判断是否包含 Emoji 的正则（覆盖大部分常见 Emoji）
    containsEmoji(str) {
      const emojiRegex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935]|[\u2190-\u21ff])/;
      return emojiRegex.test(str);
    },
    // 失去焦点时校验
    validateName(type) {
      // 动态决定字段名和错误字段名
      const field = type === 1 ? 'firstName' : 'lastName';
      const errorField = field + 'Error';
      const displayName = type === 1 ? 'First Name' : 'Last Name';

      const value = this[field].trim();

      // 1. 非空校验
      if (value === '') {
        this[errorField] = `${displayName} is required.`;
        return false;
      }

      // 2. 长度校验
      if (value.length < 1 || value.length > 100) {
        this[errorField] = `${displayName} must be between 1 and 100 characters.`;
        return false;
      }

      // 3. Emoji 校验
      if (this.containsEmoji(value)) {
        this[errorField] = `${displayName} cannot contain emojis.`;
        return false;
      }

      // 校验通过，清空错误
      this[errorField] = '';
      return true;
    },
    // 底部增加方块站位
    showBlockBottom(){
      this.showBlock = true;
      this.$nextTick(()=>{
        window.scrollTo(0, this.$refs.fr_bel.offsetHeight / 2);
      })
    },
    // 底部方块隐藏
    hideBlockBottom(){
      this.showBlock = false;
      this.validateWhatsApp()
    },
    validateWhatsApp() {
      const value = this.whatsApp.trim();
      // 1. 检查是否为空
      if (!value) {
        this.whatsAppError = 'This field is required.';
        return false;
      }
      // 2. 检查是否全为数字
      if (!/^\d+$/.test(value)) {
        this.whatsAppError = 'Only digits (0-9) are allowed.';
        return false;
      }
      // 3. 检查长度：最大 30 位
      if (value.length > 30) {
        this.whatsAppError = 'Maximum 30 digits allowed.';
        return false;
      }
      // 校验通过
      this.whatsAppError = '';
      return true;
    },
    validateRib(){
      const value = this.ribNumber.trim();
      // 1. 检查是否为空
      if (!value) {
        this.ribNumberError = 'This field is required.';
        return false;
      }
      // 2. 检查是否全为数字
      if (!/^\d+$/.test(value)) {
        this.ribNumberError = 'Only digits (0-9) are allowed.';
        return false;
      }
      // 3. 检查长度：最大 24 位
      if (value.length > 24) {
        this.ribNumberError = 'Maximum 30 digits allowed.';
        return false;
      }
      // 校验通过
      this.ribNumberError = '';
      return true;
    }
  }
}
</script>
<style scoped>

.gPayBtn{
  width: 422px;
  height: 92px;
  border-radius: 28px;
  text-align: center;
  font-size: 32px;
  line-height: 92px;
  color: #AFA9B4;
  background: #DFD9E3;
  color: #ffffff;
  background: #4D70FF;
  margin: 0 auto 14px;
}
.errBorder{
  border-color: #FF4365!important;
}
.goTop{
  height: 100vh;
  overflow-y: auto;
  /* transform: translateY(-5rem); */
}
input::placeholder {
  color: #ccc;
  opacity: 1;
}
.pay {
  width: 5.9rem;
  display: flex;
  flex-direction: column;
  margin-top: 0.4rem;
  margin: 0.4rem auto;
}

.payid {
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 17px;
  color: #000000;
}
.payid::after{
  content: '*';
  color: #FF4365;
}
.pay-ipt {
  width: 5.9rem;
  height: 0.82rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.27rem;
  line-height: 0.82rem;
  color: #000000;
  background: #f3f3f5;
  border-radius: 12px;
  border: none;
  padding-left: 0.27rem;
  padding-right: 0.27rem;
  box-sizing: border-box;
  margin-top: 0.2rem;
  border: 1px solid #CECAD1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}
.pay-ipt-box{
    height: 82px;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
}
.nameBox .pay-ipt{
  width: 290px;
  margin-top: 0;
  vertical-align: top;
}
.pay-txt {
  height: 0.58rem;
  color: #acadbc;
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.29rem;
  margin-top: 0.2rem;
}
.errtxt {
  font-size: 0.24rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.29rem;
  color: #FF4365;
  margin-top: 0.1rem;
}
</style>